import 'react-data-grid/lib/styles.css';
import './matchViewTable.css';

import React from "react";
import DataGrid from 'react-data-grid';
import {useSelector} from "react-redux";
import {IconButton, Tooltip} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import {useTranslate, useAction} from "../../../../hooks";
import {formatTime} from "../../../../helpers";

import TimerButtons from "./components/TimerButtons";
import EventsAction from "./components/EventsAction";

import {FIELD_PLAYER_EVENTS, GOALKEEPER_EVENTS} from "../../../../constants";

const MatchViewTableNoRows = () => {
    const translate = useTranslate()
    return (
        <div  className="match-view-table-empty">
            {translate['NO_DATA']}
        </div>
    )
}

// function rowClass(row: Row, rowIdx: number) {
//     return rowIdx % 2 === 0 ? 'even' : 'odd';
// }

const rowClassName = row => {
    return row.inGame ? 'match-view-table-row-active' : ''
}

const MatchViewTable = () => {
    const translates = useTranslate();
    const {players} = useSelector(state => state.player);
    const {isStart} = useSelector(state => state.match);
    const {removePlayer} = useAction()

    const eventsColumns = FIELD_PLAYER_EVENTS.map(eventName => {
        const eventsMap = {
            'SELECTIONS': 'SAVES',
            'LOSSES': 'MISSED_BALLS'
        };

        const eventsMapKeys = Object.keys(eventsMap);

        return {
            width: 95,
            key: eventName,
            name: eventsMapKeys.includes(eventName) ? `${translates[eventName]} / ${translates[eventsMap[eventName]]}` : translates[eventName],
            renderCell: ({row}) => {
                let _eventName = eventName;
                if(row.type === "GOALKEEPER" && eventsMap[eventName]) {
                    _eventName = eventsMap[eventName]
                }
                return (
                    <EventsAction playerId={row.id} eventName={_eventName}/>
                )
            }
        }
    })

    const columns = [
        {
            key: 'inGameNumber',
            name: translates['GRID_COL_NUMBER'],
            width: 75,
            renderCell: ({row}) => <span className="match-view-in-game-num">{row.inGameNumber}</span>
        },
        { key: 'name', name: translates['GRID_COL_NAME'] },
        {
            key: 'type',
            name: translates['GRID_COL_TYPE'],
            width: 80,
            renderCell: ({row}) => translates[row.type]
        },
        {
            key: 'inGameTime',
            width: 75,
            name: translates['GRID_COL_IN_GAME'] ,
            renderCell: ({row}) => formatTime(row.inGameTime/1000)
        },
        {
            key: 'inGame',
            name: translates['GRID_COL_TIMER'],
            width: 135,
            renderCell: ({row}) => <TimerButtons playerId={row.id}/>
        },
        {
            key: 'kpi',
            width: 75,
            name: translates['GRID_COL_KPI'],
            renderCell: ({row}) => row.kpi.toFixed(2)
        },
        { key: 'rank', name: translates['GRID_COL_RANK'], width: 75, },
        ...eventsColumns,
        {
            key: 'actions',
            name: '',
            width: 50,
            renderCell: ({row}) => (
                <Tooltip placement="top-end" title={translates["REMOVE_PLAYER"]}>
                    <IconButton
                        color="error"
                        size="small"
                        disabled={isStart}
                        onClick={() => {
                            removePlayer({id: row.id})
                        }}
                    >
                        <DeleteIcon/>
                    </IconButton>
                </Tooltip>
            )
        }
    ]

    return (
        <div className="match-view-table">
            <DataGrid
                style={{
                    border: 'none',
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    top: '0',
                    left: '0'
                }}
                rowClass={rowClassName}
                headerRowHeight={60}
                rowHeight={60}
                className="rdg-light"
                columns={columns}
                rows={players}
                onCellClick={(_, e) => {
                    e.preventGridDefault()
                }}
                onCellDoubleClick={(_, e) => {
                    e.preventGridDefault()
                }}
                onCellContextMenu={(_, e) => {
                    e.preventGridDefault()
                }}
                renderers={{
                    noRowsFallback: <MatchViewTableNoRows/>
                }}
            />
        </div>
    )
}

export default MatchViewTable